import '../styles/pages/datenschutzt.css'


function Datenschutz() {
    return (
        <div className="datenschutz-container">
            <h1>Datenschutzerklärung</h1>

            <div className="section">
                <strong>1. Datenschutz auf einen Blick</strong><br />
                Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </div>

            <div className="section">
                <strong>2. Verantwortliche Stelle</strong><br />
                Nurleder-Kundenservice
                E-Mail: <a href="mailto:info@nurleder.de">info@nurleder.de</a>
            </div>

            <div className="section">
                <strong>3. Erhebung und Speicherung personenbezogener Daten</strong><br />
                Wir erheben personenbezogene Daten nur, wenn Sie uns diese im Rahmen einer Bestellung, einer Registrierung oder eines Kontaktformulars freiwillig mitteilen. Die Daten werden ausschließlich zur Bearbeitung Ihres Anliegens genutzt.
            </div>

            <div className="section">
                <strong>4. Nutzung von Cookies</strong><br />
                Unsere Website verwendet Cookies. Diese dienen der Benutzerfreundlichkeit, Sicherheit und Funktionsfähigkeit der Seite. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden oder diese komplett verhindern.
            </div>

            <div className="section">
                <strong>5. Server-Log-Dateien</strong><br />
                Beim Besuch unserer Website speichert der Webserver automatisch Informationen in sogenannten Server-Log-Dateien. Diese Daten sind nicht bestimmten Personen zuordenbar.
            </div>

            <div className="section">
                <strong>6. Rechte der betroffenen Person</strong><br />
                Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer gespeicherten personenbezogenen Daten sowie ein Widerspruchsrecht gegen die Verarbeitung.
            </div>

            <div className="section">
                <strong>7. SSL-/TLS-Verschlüsselung</strong><br />
                Unsere Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung.
            </div>

            <div className="section">
                <strong>8. Externe Dienste & Plugins</strong><br />
                Falls externe Dienste wie z.B. Google Fonts, YouTube oder andere verwendet werden, informieren wir darüber separat in dieser Datenschutzerklärung.
            </div>

            <div className="section">
                <strong>9. Kontaktformular</strong><br />
                Wenn Sie uns per Formular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zur Bearbeitung der Anfrage gespeichert.
            </div>

            <div className="section">
                <strong>10. Änderung dieser Datenschutzerklärung</strong><br />
                Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen. Es gilt jeweils die aktuelle Version auf dieser Website.
            </div>
        </div>
    );
}

export default Datenschutz;